import { useGetWorkPlacesQuery } from '@services/workPlaces'
import { PER_PAGE } from '@const/pagination'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import useItemsFilters, { FilterState } from './useItemsFilters'

type Params = {
  initFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
}

const useWorkPlaces = (params?: Params) => {
  const {
    initFilters = {},
    pagination = true,
    limit = PER_PAGE,
    skip,
    initOrder,
  } = params || {}
  const { filters, setFilters, setPage, setOrder, page } = useItemsFilters(
    initFilters,
    pagination,
    limit,
    initOrder
  )

  const state = useGetWorkPlacesQuery(filters, { skip })

  return {
    ...state,
    setPage,
    setFilters,
    setOrder,
    page,
  }
}

export default useWorkPlaces
